import { BaseUseCase } from "@domains/useCases/UseCaseBase";
class GeneralSearchUseCase extends BaseUseCase {
    constructor(Repo) {
        super();
        this.Repo = Repo;
    }
    async fetchResult(data) {
        return await this.Repo.getGeneralSearch(data);
    }
}
export default GeneralSearchUseCase;
